import React, { useEffect, useState, useCallback } from 'react';
import { MapService } from '../../../services/map-service';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectMapList({ onUpdate, index, widget }) {

    const [mapList, setMapList] = useState([]);
    const [map, setMap] = useState('');
    const [isLoading, setIsLoading] = useState(false);


    const fetchData = useCallback(async (params = {}) => {

        setIsLoading(true);
        const {
            page = 1, page_size = 50, ordering = 'title'
        } = params
        let _params = {
            page: page,
            page_size: page_size,
            ordering: ordering
        }

        try {
            let mapList = await MapService.getList(_params);

            if (mapList.count === 0) {
                console.error(`No maps found`);
            } else {
                //console.log('mapList: ', mapList.results);
                setMapList(mapList.results)
                if (widget?.data && Object.keys(widget?.data)?.length > 0) {
                    setMap(widget?.data?.map_widget_id);
                }
            }
            setIsLoading(false);
        } catch (e) {
            console.error(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }, [widget])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchData();
        }, 250)
        return () => clearTimeout(delayDebounceFn)
    }, [fetchData]);

    return (
        <div>
            {!isLoading ?
                <>
                    <FormControl required sx={{ minWidth: "100%" }}>
                        <InputLabel id="widget-select-map-label">Map List</InputLabel>
                        <Select
                            labelId="widget-select-map-label"
                            id="widget-select-map"
                            value={map}
                            label="Map List *"
                            onChange={(selectedValue) => {
                                setMap(selectedValue.target.value);
                                onUpdate({
                                    map_widget_id: selectedValue.target.value,
                                }, index)
                            }}
                        >
                            {/* <MenuItem value="">
                        <em>None</em>
                    </MenuItem> */}
                            {
                                mapList?.map((e, index) => ([
                                    <MenuItem key={index} value={e.id}>{e.title}</MenuItem>
                                ]))
                            }
                        </Select>
                        {/* <FormHelperText>Required</FormHelperText> */}
                    </FormControl>
                    <div className="col-3"></div>
                </>
                : <div>...Loading</div>
            }
        </div>
    )
}